import { Controller } from "@hotwired/stimulus"
import { formatDeliveryDaysSummary } from "../lib/delivery_days_summary"

// Keeps a "(Mon, Tue, Fri)" subtext in sync with a group of day checkboxes,
// disambiguating which visual chip/pill state means "selected". Used by the
// onboarding lead-preferences step; the lead order forms do the same via their
// own page controllers.
// Connects to data-controller="delivery-days-summary"
export default class extends Controller {
  static targets = ["summary", "day"]

  connect() {
    this.update()
  }

  update() {
    if (!this.hasSummaryTarget) return
    const days = this.dayTargets
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value)
    this.summaryTarget.textContent = `(${formatDeliveryDaysSummary(days)})`
  }
}
